module.exports = __webpack_public_path__ + "img/gray_bus.dcc1731e.svg";